import { render, staticRenderFns } from "./IggElisaProcessing.vue?vue&type=template&id=96616856&scoped=true&"
import script from "./IggElisaProcessing.vue?vue&type=script&lang=js&"
export * from "./IggElisaProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96616856",
  null
  
)

export default component.exports